import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { useSelector } from 'react-redux'
import { HomeSource } from '@lmc/ts-common'

export const useIntroStep = (carerId: string, enabled = true) => {
  const homeSource = useSelector((state: any) => state.global.home.source)

  const { data, refetch } = useQuery<GetStep>(
    `step-intro`,
    () => getJSON({ url: `/api/list/carers/${carerId}/intro-steps` }),
    {
      enabled: homeSource === HomeSource.selfServe && enabled,
    },
  )

  return {
    step: data?.result?.step,
    qrCode: data?.result?.caQrcode || '',
    url: data?.result?.caUrl || '',
    refetch,
  }
}

export type GetStep = {
  result: { step: number; caQrcode?: string; caUrl?: string }
}
